import Vue from 'vue';
import {API_ROOT} from '../config'

const customActions = {
  deactivate: {method: 'PUT', url: API_ROOT + 'product{/id}/deactivate'},
  activate: {method: 'PUT', url: API_ROOT + 'product{/id}/activate'}
};

export default Vue.resource(API_ROOT + 'product{/id}', {}, customActions);



// WEBPACK FOOTER //
// ./client/resources/productResource.js